<div class="application-details-lender-task-header m-5">
    <div class="flex flex-row items-start mb-1 borrower-name-status-container">
        <div class="title-medium mr-2">{{ borrowerName }}</div>
        <lendio-deal-stage-display [stage]="deal?.stage" [status]="deal?.status" />
    </div>
    <div class="label-medium">
        <div>{{ deal?.loan_product.name }}</div>
        @if (deal?.assignments) {
            <div>Assigned to: {{ assignments }}</div>
        }
    </div>
</div>
